import React from "react";
import { FaFilter } from "react-icons/fa";
import "./FilterSectionExtract.css";

export interface FilterSectionExtractProps {
  selectedSituation?: string[];
  handleSituationFilter: (value: string | string[]) => void;
  allSituations?: string[];
}

const FilterSectionExtract = ({
  selectedSituation = [],
  handleSituationFilter,
  allSituations = [],
}: FilterSectionExtractProps) => {
  const isAllSelected =
    allSituations.length > 0 &&
    allSituations.every((s) => selectedSituation.includes(s));

  const handleToggleAll = () => {
    if (isAllSelected) return handleSituationFilter([]);
    handleSituationFilter([...allSituations]);
  };

  const handleCheckboxChange = (label: string) => {
    handleSituationFilter(label);
  };

  return (
    <div className="filters-section-extract">
      <div className="filter-label-extract">
        <FaFilter style={{ marginRight: "5px" }} /> Situação:
      </div>

      <div className="checkbox-grid-extract">
        <div className="checkbox-line-extract">
          <div className="form-check form-check-inline">
            <input
              id="filter-situation-all"
              className="form-check-input"
              type="checkbox"
              checked={isAllSelected}
              onChange={handleToggleAll}
            />
            <label className="form-check-label" htmlFor="filter-situation-all">
              Todos
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-analise-nao-finalizada"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Análise não finalizada")}
              onChange={() => handleCheckboxChange("Análise não finalizada")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-analise-nao-finalizada"
            >
              Análise não finalizada
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-extrato-pendente"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Extrato Pendente")}
              onChange={() => handleCheckboxChange("Extrato Pendente")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-extrato-pendente"
            >
              Extrato Pendente
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-extrato-enviado"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Extrato Enviado")}
              onChange={() => handleCheckboxChange("Extrato Enviado")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-extrato-enviado"
            >
              Extrato Enviado
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-extrato-recusado"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Extrato Recusado")}
              onChange={() => handleCheckboxChange("Extrato Recusado")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-extrato-recusado"
            >
              Extrato Recusado
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-extrato-validado"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Extrato Validado")}
              onChange={() => handleCheckboxChange("Extrato Validado")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-extrato-validado"
            >
              Extrato Validado
            </label>
          </div>

          <div className="form-check form-check-inline">
            <input
              id="filter-situation-inapto"
              className="form-check-input"
              type="checkbox"
              checked={selectedSituation.includes("Inapto")}
              onChange={() => handleCheckboxChange("Inapto")}
            />
            <label
              className="form-check-label"
              htmlFor="filter-situation-inapto"
            >
              Inapto
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSectionExtract;
